import { environmentBase } from '@environments/config';
import { Environment } from '@environments/model';
import { LogLevel } from '@shared/services/logs/enums';

export const environment: Environment = {
  ...environmentBase,
  production: false,
  allowIndexing: false,
  isCacheEnabled: false,
  isMockEnabled: false,
  applicationType: 'TEST',
  logLevel: LogLevel.INFO,
  API: {
    ...environmentBase.API,
    endpoint: {
      ...environmentBase.API.endpoint,
      default: 'https://cms-test.socooc.com/fournier/api',
      logs: 'https://api-test.socooc.com',
      elasticsearch: 'https://api-test.socooc.com',
      reviews: 'https://api-test.socooc.com',
      rdvs: 'https://api-test.socooc.com',
      catalogue: 'https://api-test.socooc.com',
      priceEstimator: 'https://api-test.socooc.com',
      contactEstimator: 'https://api-test.socooc.com',
      timeslots: 'https://api-test.socooc.com',
      contactB2C: 'https://api-test.socooc.com',
      contactB2B: 'https://api-test.socooc.com',
    },
  },
  domains: {
    ...environmentBase.domains,
    FR: {
      ...environmentBase.domains.FR,
      hostname: 'https://socooc-test.socooc.com',
      gtmId: undefined,
      didomiNoticeId: undefined,
      espaceClientUrl: 'https://home-test.socooc.com',
    },
    ES: {
      ...environmentBase.domains.ES,
      hostname: 'https://socooc-test.socooc.es',
      gtmId: undefined,
      didomiNoticeId: undefined,
      espaceClientUrl: 'https://home-test.socooc.es',
    },
    BE: {
      ...environmentBase.domains.BE,
      hostname: 'https://socooc-test.socooc.be',
      gtmId: undefined,
      didomiNoticeId: undefined,
    },
  },
  integrations: {
    ...environmentBase.integrations,
    fournierWebservice: {
      ...environmentBase.integrations!.fournierWebservice!,
      index_models: 'indice-socooc-test-models',
      index_store: 'indice-socooc-test-store',
      index_packs: 'indice-socooc-test-packs',
      index_finitions: 'indice-socooc-test-finitions',
      index_tutos: 'indice-socooc-test-tutos',
      index_promotions: 'indice-socooc-test-promotions',
      index_blog: 'indice-socooc-test-blog',
      index_opportunities: 'indice-socooc-test-opportunity',
      index_faq: 'indice-socooc-test-faq',
      index_temoignages: 'indice-socooc-test-temoignages',
      index_sem: 'indice-socooc-test-sem',
      index_realisations: 'indice-socooc-test-realisations',
      index_mur_realisations: 'indice-socooc-test-mur_realisations',
      index_popins: 'indice-socooc-test-popin',
      index_teams: 'indice-socooc-test-teams',
    },
    requestMetrics: undefined,
  },
  AUTH0: {
    domain: 'auth-test.espace-client.fourniergroupe.com',
    clientId: 'ARhvWKwuGzsJ8UI88yCucltMICjIxHVS',
    audience: 'https://user-service.dev.fournier.com',
  },
};
